import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import WhatsAppCTA from "./WhatsAppCTA";
import { getLocationBySlug } from "../data/locations.ts";
import { inferWhatsAppContext } from "../lib/whatsapp";

export default function FloatingWhatsApp() {
  const location = useLocation();
  const params = useParams();
  const whatsappContext = useMemo(() => inferWhatsAppContext(location.pathname), [location.pathname]);

  const locationName = useMemo(() => {
    if (params.locationSlug) {
      return getLocationBySlug(params.locationSlug)?.city;
    }
    const segments = location.pathname.split("/").filter(Boolean);
    if (segments[0] && segments[1] && segments[0] !== "services") {
      const city = getLocationBySlug(segments[1])?.city;
      return city;
    }
    return undefined;
  }, [location.pathname, params.locationSlug]);

  return (
    <WhatsAppCTA
      serviceName={whatsappContext.servicePage}
      serviceType={whatsappContext.serviceType}
      sourcePage={whatsappContext.sourcePage}
      sourcePath={whatsappContext.sourcePath}
      locationName={locationName}
      variant="floating"
    />
  );
}
